import notification from "@/parts/Front/components/notification/classes/notification";

export default {
  // این تابع برای دریافت استاتوس لاگین است
  // از این تابع میتوانید هرجا که نیاز داشتید لاگین بودن کاربر را چک کنید استفاده کنید
  getLoginStatus(state) {
    return state.loginStatus;
  },
  getUserFavorite(state) {
    let user = state.mainContent.user;
    if (!user) {
      return null;
    }
    let userUser = state.mainContent.user.user;
    if (!userUser) {
      return null;
    }
    return userUser.favorites;
  },

  getFullName(state) {
    let user = state.mainContent.user;
    if (!user) {
      return null;
    }
    let userUser = state.mainContent.user.user;
    if (!userUser) {
      return null;
    }
    if (userUser.full_name) {
      return userUser.full_name;
    }
    return userUser.mobile;
  },
  getNotifications(state) {
    return state.mainContent.user && state.mainContent.user.notifications
      ? {
          items: state.mainContent.user.notifications.items.map(
            (item) => new notification(item)
          ),
          totalUnread: state.mainContent.user.notifications.total_unread,
        }
      : null;
  },
  getRealNotifications() {
    return state.mainContent.user && state.mainContent.user.notifications
      ? state.mainContent.user.notifications
      : null;
  },
  getMenuHeader(state) {
    return state.menu.header;
  },
  getMenuFooter(state) {
    return state.menu.footer;
  },
  getUser(state) {
    return state.mainContent.user;
  },
  getSettings(state) {
    return state.mainContent.settings;
  },
  getCategories(state) {
    return state.mainContent.categories;
  },
  
  getSizeValues(state) {
    return state.mainContent.sizeValues;
  },
  getCartRequest(state) {
    return state.mainContent.cartRequest;
  },
  getColors(state) {
    return state.mainContent.colors;
  },
  getGateWays(state) {
    return state.mainContent.gateWays;
  }
};
